Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    boxShadows = _STYLES$useStyles.boxShadows,
    fontRegular = _STYLES$useStyles.fontRegular;
  var container = {
    zIndex: 1,
    flexDirection: 'row'
  };
  var container_top = {
    marginBottom: (0, _styles.getREM)(-0.5)
  };
  var container_bottom = {
    marginTop: (0, _styles.getREM)(-0.5)
  };
  var imageContainer = Object.assign({}, boxShadows.card.all, {
    width: (0, _styles.getREM)(2),
    height: (0, _styles.getREM)(2),
    borderRadius: (0, _styles.getREM)(1),
    borderStyle: 'solid',
    borderColor: COLORS.white,
    borderWidth: (0, _styles.getREM)(0.125),
    backgroundColor: COLORS.aubergine,
    overflow: 'hidden'
  }, _reactNative.Platform.select({
    android: {
      lineHeight: (0, _styles.getREM)(2.125)
    },
    "default": {
      lineHeight: (0, _styles.getREM)(1.75)
    }
  }));
  var imageContainer_pointerOver = Object.assign({}, boxShadows.card_pointerOver.all);
  var image = {
    width: (0, _styles.getREM)(1.75),
    height: (0, _styles.getREM)(1.75),
    backgroundColor: COLORS.white
  };
  var text = Object.assign({}, fontRegular, {
    color: COLORS.white,
    fontSize: _styles.STYLES.fontSize.s,
    textAlign: 'center'
  }, _reactNative.Platform.select({
    android: {
      lineHeight: (0, _styles.getREM)(2)
    },
    "default": {
      lineHeight: (0, _styles.getREM)(1.75)
    }
  }));
  var styles = _reactNative.StyleSheet.create({
    container: container,
    container_top: container_top,
    container_bottom: container_bottom,
    imageContainer: imageContainer,
    imageContainer_pointerOver: imageContainer_pointerOver,
    image: image,
    text: text
  });
  return {
    styles: styles
  };
};